import React from 'react';
import CreateReactClass from 'create-react-class';

import Reactor from 'data/reactor';
import PropTypes from 'prop-types';

import Analytics from 'utils/analytics';
import RuntimeGetters from 'data/app-runtime/getters';
import CommonValues from 'resources/common-values';
import CommonStrings from 'resources/common-strings';

import HelpBox from 'components/generic/help/index';

export default CreateReactClass({
    displayName: 'share-options',

    PropTypes: {
        selectBatchPrintPDF: PropTypes.func,
        togglePrintAndShare: PropTypes.func,
        isHelpBoxOpen: PropTypes.func,
        reportQueueLink: PropTypes.string.isRequired,
    },

    printPage(event) {
        const selectedModule = Reactor.evaluate(RuntimeGetters.expandedModule)
            ? Reactor.evaluate(RuntimeGetters.expandedModule)
            : 'default';
        Analytics.recordButtonClick(CommonValues.SectionIDs.printAndShare, 'print-screen', selectedModule);

        this.props.togglePrintAndShare(event);
        window.print();
    },

    printScreenHelpText() {
        return CommonStrings.printAndShareHelp.printScreen;
    },

    batchPDFHelpText() {
        return CommonStrings.printAndShareHelp.batchPDF;
    },
    familyReportPDFHelpText() {
        return CommonStrings.printAndShareHelp.familyBatchPDF;
    },

    render() {
        return (
            <div className="print-share-options">
                <div className="printing">
                    <h5>PRINT</h5>
                    <div className="print-share-item" onClick={this.printPage}>
                        <span>Print Screen</span>
                        <i key="print-icon" id="print-icon" className="icon icon-print-current-screen" />
                        <HelpBox
                            id="print-current-page-help"
                            helpContentsRenderer={this.printScreenHelpText}
                            isHelpBoxOpen={this.props.isHelpBoxOpen}
                            moduleName={CommonValues.SectionIDs.printAndShare}
                            helpLabel="print-screen-help"
                        />
                    </div>
                </div>
                <div className="download">
                    <h5>
                        DOWNLOAD
                        <p className="reports-queue-link">
                            Looking for your PDF? go to the &nbsp;
                            <a
                                key="reports-queue"
                                href={this.props.reportQueueLink}
                                onClick={() =>
                                    Analytics.recordButtonClick(
                                        CommonValues.SectionIDs.printAndShare,
                                        'goto-reports-queue',
                                        'print-and-share'
                                    )
                                }
                            >
                                Reports Queue
                            </a>
                            .
                        </p>
                    </h5>
                    <div className="print-share-item download-batch-pdfs" onClick={this.props.selectBatchPrintPDF}>
                        <span>Batch PDF</span>
                        <i key="download-icon" id="download-icon" className="icon icon-download-batch-pdfs" />
                        <HelpBox
                            id="download-batch-print-content"
                            helpContentsRenderer={this.batchPDFHelpText}
                            isHelpBoxOpen={this.props.isHelpBoxOpen}
                            moduleName={CommonValues.SectionIDs.printAndShare}
                            helpLabel="batch-pdf-help"
                        />
                    </div>
                    <div
                        className="print-share-item download-batch-pdfs"
                        onClick={() => this.props.selectBatchPrintPDF('family')}
                    >
                        <span>Family Report PDF</span>
                        <i
                            key="download-icon"
                            id="download-icon"
                            className="icon icon-download-batch-pdfs icon-family-report"
                        />
                        <HelpBox
                            id="download-family-batch-print-content"
                            helpContents={CommonStrings.printAndShareHelp.familyBatchPDF}
                            helpContentsRenderer={this.familyReportPDFHelpText}
                            moduleName={CommonValues.SectionIDs.printAndShare}
                            helpLabel="family-batch-pdf-help"
                        />
                    </div>
                </div>
            </div>
        );
    },
});
